import { useEffect } from "react";

export function Modif() {
  useEffect(() => {
    window.location.replace("https://o-kiosque.fr/modif");
  }, []);

  return <div></div>;
}
